import { render, staticRenderFns } from "./DriversFieldGroupsEdit.vue?vue&type=template&id=571cff45&"
import script from "./DriversFieldGroupsEdit.vue?vue&type=script&lang=js&"
export * from "./DriversFieldGroupsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports